import { DOCUMENT, Location } from '@angular/common';
import { inject, Inject, Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { Redirection } from './redirection';
import { environment } from '@tytapp/environment';
import { filter } from 'rxjs/operators';
import { LoggerService } from './logger.service';

@Injectable({
    providedIn: 'root'
})
export class CanonicalURLService {
    private dom = inject(DOCUMENT);
    private router = inject(Router);
    private location = inject(Location);
    private redirection = inject(Redirection);
    private logger = inject(LoggerService);

    constructor() {
        this.watchRouteNavigation();
    }

    public redirectToCanonical(canonicalUrl: string) {
        this.setCanonicalURLManually(canonicalUrl);
        let currentUrl = this.location.path(false).replace(/\?.*/, '');
        if (currentUrl !== canonicalUrl) {
            if (environment.showDevTools) {
                this.logger.info(`[Canonical URL] Redirecting to canonical URL ${canonicalUrl}`);
            }
            this.redirection.go(canonicalUrl, true);
            return true;
        }

        return false;
    }

    private watchRouteNavigation(): void {
        this.router.events
            .pipe(
                filter(event => event instanceof NavigationStart)
            )
            .subscribe((event: NavigationStart) => this.setURL(event.url));
    }

    public setCanonicalURLManually(url: string) {
        this.setURL(url);
    }

    private setURL(url: string): void {

        const canonicalURL = `${environment.urls.webRoot}${url}`;
        let linkTag = this.getLinkTag();

        if (!linkTag) {
            linkTag = this.dom.createElement('link');
            linkTag.setAttribute('rel', 'canonical');
            this.dom.head.appendChild(linkTag);
        }

        linkTag.setAttribute('href', canonicalURL);
    }

    private getLinkTag(): HTMLLinkElement {
        const list = (Array.from(this.dom.getElementsByTagName('link')) as HTMLLinkElement[])
            .find(l => l.rel === 'canonical');
        return list;
    }

}
